import {defineStore} from 'pinia';

export const useFilterStore = defineStore('filterStore', {
    state: () => ({
        filters: {
            query: '',
            currentPage: 1,
            lastPage: 1,
            under3: false,
            over3: false,
            maxFreeFallHeight: 3,
            safetyAreaWidth: null,
            safetyAreaDepth: null,
            priceFrom: null,
            priceTo: null,
            order: null,
            selectedInclusionIcons: [],
        },
    }),
    /* getters: {
        filters: (state) => state.filters,
    }, */
    actions: {
        reset() {
            this.filters = {
                query: '',
                currentPage: 1,
                lastPage: 1,
                under3: false,
                over3: false,
                maxFreeFallHeight: 3,
                safetyAreaWidth: null,
                safetyAreaDepth: null,
                priceFrom: null,
                priceTo: null,
                order: null,
                selectedInclusionIcons: [],
            };
        },
    },
});
